const initialState = {
    quickReplies: [],
    loading: false,
};

export const quickRepliesReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_QUICK_REPLIES':
            return {
                ...state,
                quickReplies: action.payload,
                loading: action.loading ?? false,
            };
        default:
            return state;
    }
};
